import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Add more detailed error checking
if (!supabaseUrl) {
    throw new Error('Missing VITE_SUPABASE_URL environment variable');
}
if (!supabaseAnonKey) {
    throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable');
}

console.log('Initializing Supabase client...'); // Add this for debugging
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
    id: string;
    email: string;
    full_name: string;
    avatar_url: string;
    created_at: string;
    updated_at: string;
}

export type Recording = {
    id: string;
    user_id: string;
    name: string;
    audio_url: string;
    transcript: string;
    duration: number;
    created_at: string;
    updated_at: string;
}

export type Transcription = {
    id: string;
    user_id: string;
    text: string;
    title?: string;
    summary?: string;
    audio_url: string;
    duration: number;
    language: string;
    model: string;
    created_at: string;
    updated_at: string;
}
